import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import { Count } from '../Count/Count';

import styles from './MoreButton.module.scss';

type Props = ComponentPropsWithoutRef<'button'> & {
	/**
	 * specify this property to display the count of the more button
	 */
	count?: string | number;
};

/**
 * Implements the more button component, with an additional count.
 *
 * To display the count add a count property and it will be displayed after the content of the button.
 *
 * @param props
 *
 */
export function MoreButton({ children, className = '', count, ...buttonProps }: Props) {
	let countElement: ReactNode = null;
	if (count != null) {
		countElement = <Count count={count} />;
	}

	return (
		<button className={`${styles.moreButton} ${className}`} {...buttonProps}>
			{children}
			{countElement}
		</button>
	);
}
